export const INVOICES_OVERVIEWS_PAGE_SIZE = 50;
